module.exports = __webpack_public_path__ + "images/logo-loudup-new.png?3c4c1";